import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import './navbar.css';

function Navbar() {

    const [click, setClick] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const updateWidth = () => {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', updateWidth);
        return () => {
            window.removeEventListener('resize', updateWidth);
        }   
    }, []);
    const handleClick = () => {
        if(width <= 500) {
            setClick(!click);
        }
    };
    const navigate = useNavigate();

    return (
        <div className="navbar">
            <div className="navbarLogo" onClick={()=>navigate('/')} style={{cursor: 'pointer'}}>
                <img src="https://ik.imagekit.io/nvo8yi18o/VETOMAC/Navbar/iitrLogo_gTlR1gpMI.svg?updatedAt=1679926585447" />
                <img src="https://ik.imagekit.io/nvo8yi18o/VETOMAC/Navbar/175_logo_aGCIhpMG7.svg?updatedAt=1679927297632" />
            </div>
            <nav>
                <ul className={click ? "mobile" : "not-mobile"}>
                    <li>
                        <NavLink to="/" className={({isActive}) => (isActive ? 'active' : 'inactive')} onClick={handleClick}>
                            Home
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/registration" className={({isActive}) => (isActive ? 'active' : 'inactive')} onClick={handleClick}>
                            Registration
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/abstracts" className={({isActive}) => (isActive ? 'active' : 'inactive')} onClick={handleClick}>
                            Call for Abstracts
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/keynotes" className={({isActive}) => (isActive ? 'active' : 'inactive')} onClick={handleClick}>
                            Keynotes
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/committees" className={({isActive}) => (isActive ? 'active' : 'inactive')} onClick={handleClick}>
                            Committees
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/contact" className={({isActive}) => (isActive ? 'active' : 'inactive')} onClick={handleClick}>
                            Contact
                        </NavLink>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default Navbar;